var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-read-more"},[_c('div',[_c('span',[_vm._v("Read more")]),_c('IconPlus',{attrs:{"colour":_vm.colour}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }